/**
 * Durations in milliseconds, and the two byte sizes that read the same way.
 *
 * `24 * 60 * 60 * 1000` was written eighty-two times across sixty-two modules,
 * `60 * 60 * 1000` thirty-two more, and one of them backwards as
 * `1000 * 60 * 60 * 24`. A named constant says what the number MEANS at the
 * callsite, which an arithmetic chain does not.
 */
export const SECOND_MS = 1000;
export const MINUTE_MS = 60 * SECOND_MS;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;
export const WEEK_MS = 7 * DAY_MS;

export const KILOBYTE = 1024;
export const MEGABYTE = 1024 * KILOBYTE;

/**
 * The same spans in SECONDS, for the two APIs that count that way: a cookie's
 * `maxAge` and Better Auth's `expiresIn`.
 */
const DAY_SECONDS = 60 * 60 * 24;
export const WEEK_SECONDS = 7 * DAY_SECONDS;
export const YEAR_SECONDS = 365 * DAY_SECONDS;
